// extracted by mini-css-extract-plugin
export default {"storyDetailHeaderDescription":"c-r_hj","storyDetailHeaderDescription__time":"c-r_hk"};